// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = [
  require('./all').name,
  require('./unprocessed').name,
  require('./archived').name,
  require('./ledger').name,
  require('ui/web/accountSelect').name,
];

module.exports = angular
  .module('bench.app.dms.statements', deps)

  .config($stateProvider =>
    $stateProvider.state('bench.dms.statements', {
      abstract: true,
      url: '/statements',
      template: `\
<div class="statements">
  <bl-account-select>
  </bl-account-select>
  <div
    class="statements_card-wrapper"
    ui-view>
  </div>
</div>\
`,
    }),
  );
